import { application } from "./application";

import CampaignUrlController from "./campaign_url_controller";
import CampaignUrlControllerValue from "./campaign_url_value_controller";

application.register("campaign-url", CampaignUrlController);
application.register("campaign-url-value", CampaignUrlControllerValue);
